module.exports = __webpack_public_path__ + "img/cydcf.842d5806.png";